module.exports = __webpack_public_path__ + "img/1.63f9b4a1.jpg";